module.exports = __webpack_public_path__ + "static/media/twitter-icon.5d931306.svg";